import { QueryClient } from '@tanstack/react-query';

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
			refetchOnMount: false,
			retry: false,
			// retry: 5,
			// retryDelay: (failureCount) => failureCount * 5000 + 5000,
		},
	},
});

export default queryClient;
